module.exports = __webpack_public_path__ + "img/location.5dcc703b.svg";